import controller from './user-details-form.controller'
import template   from './user-details-form.html'
import './user-details-form.styl'

let component = {
  restrict: 'E',
  bindings: {
    form: '=',
    onSubmit: '&',
    onCancel: '&'
  },
  transclude: true,
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/components/user-details-form/user-details-form.component.js